export default function (context, {field, value}) {
    let data = {};
    switch (field) {
        case 'Contragent':
            data = {
                ContragentId: value.value,
                ContragentName: value.label,
                ContragentType: value.type,
            };
            switch (value.type) {
                case 'partner':
                    setTimeout(()=>{
                        context.dispatch('get_legal', {PartnerId: value.value});
                    });
                    break;
            }
            break;
        default:
            data[field] = value;
    }
    context.commit('set', data);
}